import { t } from "i18next";
import { useContext } from "react";
import { useNavigate } from "react-router";

import FilterableTableLayout from "../../../../components/FilterableTableLayout/FilterableTableLayout";
import { PersistedFilterKeys } from "../../../../modules/filters/filters.types";
import {
  getMfinExciseWarehouseFilterItems,
  getMfinExciseWarehouseTableColumns,
  MFIN_EXCISE_WAREHOUSE_INITIAL_FILTERS,
} from "../../../../modules/ministry/ministry.constants";
import { MinistryContext } from "../../../../modules/ministry/ministry.context";
import { useMfinExciseWarehouseList } from "../../../../modules/ministry/ministry.queries";
import {
  MfinExciseWarehouse,
  MfinExciseWarehouseListPayload,
  MfinExciseWarehouseListResponse,
} from "../../../../modules/ministry/ministry.types";
import style from "./MinistryWarehouseList.module.scss";

export const MinistryWarehouseList = () => {
  const { setMinistry } = useContext(MinistryContext);
  const navigate = useNavigate();

  const onTableRowClickHandler = (record: MfinExciseWarehouse) => {
    setMinistry({ selectedWarehouseId: record.skladisteId });
    navigate(`/mfin/listaSkladista/zahtev?id=${record.skladisteId}`);
  };

  return (
    <FilterableTableLayout<
      MfinExciseWarehouse,
      MfinExciseWarehouseListResponse,
      MfinExciseWarehouseListPayload
    >
      tableRowKey="id"
      tableName="ministry_excise_warehouse_table"
      toolbarId="ministry_warehouse_list"
      title={t("SKLADISTA.LISTA_SKLADISTA")}
      getTableColumns={getMfinExciseWarehouseTableColumns}
      queryHook={useMfinExciseWarehouseList}
      onTableRowClick={onTableRowClickHandler}
      filterProps={{
        getFilterItems: getMfinExciseWarehouseFilterItems,
        initialFilters: MFIN_EXCISE_WAREHOUSE_INITIAL_FILTERS,
        persistedFilterKey: PersistedFilterKeys.MFIN_EXCISE_WAREHOUSE_LIST,
        filterToolbarClassName: style.filterToolbar,
      }}
      dataListKey="warehouseList"
    />
  );
};
